import { i18n } from '@fs/zion-locale'

export default {
  qualityTagsHeader: () => i18n.t('qualityTags.qualityTagsHeader', 'Comments and Quality Tags'),
  qualityTags101: () => i18n.t('qualityTags.qualityTags101', 'Tight Binding'),
  qualityTags102: () => i18n.t('qualityTags.qualityTags102', 'Faded or Damaged Documents'),
  qualityTags103: () => i18n.t('qualityTags.qualityTags103', 'Poor Copy of Original'),
  qualityTags104: () => i18n.t('qualityTags.qualityTags104', 'Plastic Covered or Shiny Paper'),
  qualityTags105: () => i18n.t('qualityTags.qualityTags105', 'Sequence Error'),
  qualityTags106: () => i18n.t('qualityTags.qualityTags106', 'Glued or Covered Information'),
  qualityTags107: () => i18n.t('qualityTags.qualityTags107', 'Cover Unavailable or Missing'),
  qualityTags108: () => i18n.t('qualityTags.qualityTags108', 'Cover Will Not Be Captured'),
  qualityTags201: () => i18n.t('qualityTags.qualityTags201', 'Image may have Publishing Restrictions'),
  qualityTags202: () => i18n.t('qualityTags.qualityTags202', 'Imported Images'),
}
